<template>
	<div class="My_pop _popRight _popdetails" id="POP-CAdetails-1" style="display: block;">
		<!-- POP -->
		<div class="pop_right " style="right: 0px;" v-loading="loadingMask">
			<!-- pop_right -->
			<ul class="pop_right_header2">
				<li>
					<h2>解除集团绑定</h2>
				</li>
				<li>
					<btn class="pop_right_close2" name="pop-details-close" @click="closeFloat"></btn>
				</li>
			</ul>
			<div class="pop_right_main">
				<!-- main -->


				<ul class="form_list">
					<li>
						<h4>验证码</h4>
						<div class="input_out">
							<div class="input_inner">
								<div class="input_box">
									<input type="text" class="s_input" v-model="phonecode" placeholder="请输入验证码">
									<btn class="s_btn" style="margin:0;min-width: 144px;" @click="sendPhoneCode"
										:disabled="phonecountdown>0">{{phonecountdown?phonecountdown:'获取验证码'}}</btn>
								</div>
							</div>
						</div>
					</li>
				</ul>


			</div><!-- /main -->

			<div class="pop_right_footer2">
				<btn class="s_btn" @click="quxiaoSubmit()">确定</btn>
			</div>

		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				phonecode: '',
				phonecountdown: 0,
				phonetimer: '',
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			if (this.$cookies.get('phonecountdown') && parseInt(this.$cookies.get('phonecountdown'))) {
				this.setPhoneCountdown(parseInt(this.$cookies.get('phonecountdown')));
			}
		},
		methods: {
			sendPhoneCode: function() {
				let _this = this;
				if (_this.phonecountdown > 0) {
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				_this.phonecountdown = 60;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/getUnbindCodeInfo',
						// responseType: 'json',
						params: {
							pnum: "-1"
						},
					})
					.then(function(response) {
						var text = response.data.data.data;
						var arr = text.split('_');
						var m = arr[1] == "1" ? "手机" : "邮箱";
						if (arr[0] == "-1") {
							_this.$message({
								message: '发送失败',
								type: 'warning'
							});
							_this.phonecountdown = 0;
						} else {
							_this.$message({
								message: '发送成功',
								type: 'success'
							});
							_this.setPhoneCountdown(60);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.phonecountdown = 0;
						_this.loadingMask = false;
						console.log(error);
					});
			},
			setPhoneCountdown: function(num) {
				let _this = this;
				_this.phonecountdown = num;
				clearInterval(_this.phonetimer);
				_this.phonetimer = setInterval(function() {
					// debugger;
					if (_this.phonecountdown > 1) {
						_this.phonecountdown--;
						_this.$cookies.set('phonecountdown', _this.phonecountdown, _this.phonecountdown);
					} else {
						_this.phonecountdown = 0;
						clearInterval(_this.phonetimer);
						_this.$cookies.remove('phonecountdown');
					}
				}, 1000);
			},
			quxiaoSubmit: function(){
				if(!this.phonecode){
					this.$message({
						message: '请填写验证码',
						type: 'warning'
					});
					return false;
				}
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/Unbind',
						responseType: 'json',
						params: {
							uncode: this.phonecode
						},
					})
					.then(function(response) {
						var text = response.data.data.data
						if (text == "1") {
							_this.$alert('解绑成功！', '成功', {
								confirmButtonText: '确定',
							});

							_this.$track([
								['pagetype', '接触集团绑定']
							]);

							_this.closeFloat();
						} else {
							_this.$alert('解绑失败！', '失败', {
								confirmButtonText: '确定',
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},

		},
	}
</script>

<style>
</style>
